import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { formatDefaultLocale } from 'd3';
import { createCookieMiddleware } from 'redux-cookie';
import Cookies from 'js-cookie';
import AppLegacy from '../../legacy/indexpage/App.jsx';
import App from './App.jsx';
import rootReducer from './reducer';
import { initWorldConnector, propertyBookLoaded } from '../WorldConnector.jsx';
import { getMarketingFocusUpdater } from '../../utils/marketingFocusUpdater.js';
import { getUserIntentUpdater } from '../../utils/userIntentUpdater.js';
import { DEFAULT_MARKETING_FOCUS } from '../../realEstateTypes.js';
import { DEFAULT_USER_INTENT } from '../../userIntents.js';

import { isRenderedInBrowser } from '../../store/configureStore';
import featureSwitchReader from '../../utils/featureSwitchReader';
import featureSwitchReaderFactory from '../../utils/featureSwitchReader';
import { HOME_PAGE_REDESIGN } from '../../utils/featureFlags';

let enhancer;
if (isRenderedInBrowser()) {
  if (typeof window.process === 'undefined') {
    // HACK(keanulee): The Redux package assumes `process` exists - mock it here before the module is loaded.
    window.process = {
      env: {
        NODE_ENV: 'production',
      },
    };
  }

  featureSwitchReader.set(window.IS24.PropertyBook.featureSwitches);

  enhancer = applyMiddleware(thunkMiddleware, createCookieMiddleware(Cookies, '/indexpage/cookie/'));

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancer = compose(enhancer, window.__REDUX_DEVTOOLS_EXTENSION__());
  }
}

window.INITIAL_STATE = window.INITIAL_STATE || {};

const store = createStore(rootReducer, window.INITIAL_STATE, enhancer);

store.subscribe(getMarketingFocusUpdater(store, DEFAULT_MARKETING_FOCUS));
store.subscribe(getUserIntentUpdater(store, DEFAULT_USER_INTENT));

formatDefaultLocale({
  // d3 settings
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['', '\u00a0€'],
});

initWorldConnector(store);

const isFeatureOn = featureSwitchReaderFactory.getInstance().isFeatureOn;

ReactDOM.render(
  <Provider store={store}>{isFeatureOn(HOME_PAGE_REDESIGN) ? <App /> : <AppLegacy />}</Provider>,
  document.getElementById('app'),
);

propertyBookLoaded();
